import type { WSRequestsBody } from '@patrianna/shared-patrianna-types/websocket/requests'
import type { Dispatch, UnknownAction } from '@reduxjs/toolkit'

import { KeepAlive } from './keepAlive'

// import createHmac from 'src/utils/createHmac'

export type InstanceWSProps = {
  connect: (dispatch: Dispatch<UnknownAction>) => Promise<unknown>
  disconnect: () => void
  getInstance: () => null | WebSocket
  emitWS: (event: WSRequestsBody) => () => void
  clear: () => void
}

export const WSinstance = ((): InstanceWSProps => {
  let socketRoot: null | WebSocket = null
  const keepAlive = new KeepAlive()

  // redux action
  const emitWS = (event: WSRequestsBody) => () => {
    // console.log('emitWS is deprecated, move request to REST API', event)
    keepAlive.send(event)
  }

  const clear = () => {
    socketRoot = null
    keepAlive.clearSocket()
  }

  const connect = (dispatch: Dispatch<UnknownAction>): Promise<unknown> => {
    return new Promise((resolve) => {
      const platform = 'web'
      const SERVER_URL = `${process.env.WEBSOCKET}/ws?brandName=${process.env.BRAND_NAME}&platform=${platform}`

      socketRoot = new WebSocket(SERVER_URL)
      // @ts-ignore
      window.soc = socketRoot // test
      keepAlive.initSocket(socketRoot)

      socketRoot.onopen = () => {
        keepAlive.polling()
        dispatch({ type: 'INIT_SOCKET_LISTENERS' })
        resolve(true)
      }
    })
  }

  const disconnect = () => {
    console.info('ws disconnect')
    socketRoot?.close(4444)

    keepAlive.stopPolling()

    socketRoot = null
  }

  return {
    getInstance() {
      return socketRoot
    },
    connect,
    disconnect,
    emitWS,
    clear,
  }
})()

const managementWS = {
  connectingTimer: null as ReturnType<typeof setTimeout> | null,

  cancel() {
    clearTimeout(this.connectingTimer)
    this.connectingTimer = null
  },

  disconnect() {
    if (typeof this.connectingTimer === 'number') {
      this.cancel()
    }

    this.connectingTimer = setTimeout(() => {
      WSinstance.disconnect()
      this.cancel()
    }, 5000)
  },

  connect(dispatch: Dispatch<UnknownAction>): Promise<unknown> | null {
    if (typeof this.connectingTimer === 'number') {
      this.cancel()

      return null
    }

    const socket = WSinstance.getInstance()

    if (!socket || WebSocket.CLOSED === socket?.readyState) {
      WSinstance.connect(dispatch)
    }

    return null
  },
}

export const appStateInactiveHandler = () => () => {
  const socket = WSinstance.getInstance()

  if (socket) {
    managementWS.disconnect()
  }
}

export const appStateActiveHandler = () => (dispatch: Dispatch<UnknownAction>) => {
  managementWS.connect(dispatch)
}

// Export for testing
export const __managementWS_test_helper__ = managementWS
